const editors = new WeakMap();
const clone = value => JSON.parse(JSON.stringify(value));
const identity = row => JSON.stringify([row.ID, row.ID_ATENDIMENTO_DETALHE, row.ID_ATENDIMENTO_DETALHE_LOG, row.ID_ATENDIMENTO, row.ID_ATENDIMENTO_TIPO, row.TPC, row.DATA_INCLUSAO]);
const context = vm => JSON.stringify([vm.$route.fullPath, vm.$route.params.id, identity(vm.atendimento)]);

export function configuracoesEditor(usuario) {
  return [
    ["2", "GERAL", "FATURAMENTO ", "PEP_ALTERA_EXCLUI_PASSADO", ""],
    ["4", usuario, "ATENDIMENTO ", "ALT_ATEND_DIF_HOJE", ""],
    ["4", usuario, "ATENDIMENTO", "TAMANHO_FONTE_ATENDIMENTO", "11"],
    ["4", usuario, "ATENDIMENTO", "NOME_FONTE_ATENDIMENTO", "Tahoma"],
    ["2", "GERAL", "ATENDIMENTO", "ALTURA_TELA_ATENDIMENTO", "475"],
    ["2", "GERAL", "ATENDIMENTO", "SINAL_RESUL_CAMPO_CALC", "0"]
  ].map(([NIVEL, USUARIO, MODULO, CAMPO, CONTEUDO]) => ({ CONTEUDO_NOME: "CONTEUDO", NIVEL, OPERACAO: "C", USUARIO, SISTEMA: "CLMADV", MODULO, CAMPO, CONTEUDO }));
}

export async function consultarConfiguracoesEditor(api, jwt, { configuracoes, signal }) {
  if(!jwt.getToken()) { throw new Error("Sessão indisponível para carregar a ficha."); }
  api.setHeader();
  const { data } = await api.postOnce("configuracoes/access/buscarConfiguracoesMasterMultiplas", configuracoes, { signal, timeout: 120000 });
  if(!Array.isArray(data) || data.some(row => !row || typeof row.MODULO !== "string" || typeof row.CAMPO !== "string")) {
    throw new Error("Resposta inválida das configurações da ficha.");
  }
  return data;
}

export function editorFichaHistorico(vm, moment) {
  if(!editors.has(vm)) { editors.set(vm, criarEditorFichaHistorico(vm, moment)); }
  return editors.get(vm);
}

export function criarEditorFichaHistorico(vm, moment) {
  let current = null, last = null, applied = null, disposed = false;
  const valid = request => !disposed && current === request && request.context === context(vm) && vm.$refs.modalDetalhe?.showModal;
  const loading = value => {
    vm.carregandoFichaHistorico = value;
    vm.$refs.atendimentoFichaDados?.definirCarregamentoFichas(value);
  };
  function cancelar() {
    current?.controller.abort();
    current = last = applied = null;
    vm.fichaHistoricoPronta = false;
    vm.fichaHistoricoAtendimento = null;
    vm.erroFichaHistorico = "";
    vm.fichaHistoricoPodeRepetir = false;
    loading(false);
  }
  function abrir(editar = false, atendimento = {}) {
    if(disposed || vm.isLoading) { return Promise.resolve(false); }
    const row = atendimento?.DADOS ? atendimento : vm.atendimento;
    if(!row?.ID_ATENDIMENTO_TIPO || !Array.isArray(row.DADOS) || !row.DADOS.length) { return Promise.resolve(false); }
    const rowKey = identity(row), key = JSON.stringify([rowKey, editar]);
    if(current?.promise && current.context === context(vm) && current.key === key) { return current.promise; }
    if(applied?.context === context(vm) && vm.$refs.modalDetalhe?.showModal) {
      if(applied.key === key && vm.fichaHistoricoPronta) { return Promise.resolve(true); }
      if(applied.editar && (applied.rowKey !== rowKey || !editar)) {
        vm.$swal({ icon: "warning", title: "Ficha em edição", text: "Conclua ou cancele a edição atual antes de abrir outra ficha nesta janela." });
        return Promise.resolve(false);
      }
    }
    current?.controller.abort();
    const request = { key, rowKey, editar, row: clone(row), context: context(vm), controller: new AbortController(), promise: null };
    current = request; last = request;
    vm.erroFichaHistorico = ""; vm.fichaHistoricoPodeRepetir = false; vm.fichaHistoricoPronta = false;
    loading(true);
    request.promise = Promise.resolve().then(async () => {
      try {
        if(disposed || current !== request || request.context !== context(vm)) { return false; }
        if(!vm.$refs.modalDetalhe) { throw new Error("Janela indisponível."); }
        if(!vm.$refs.modalDetalhe.showModal) { await vm.$refs.modalDetalhe.toggleModal(); }
        if(!valid(request)) { return false; }
        const configuracoes = await vm.consultarConfiguracoesFichaHistorico({ configuracoes: configuracoesEditor(vm.usuario), signal: request.controller.signal });
        if(!valid(request)) { return false; }
        const values = {};
        for(const cfg of configuracoes) {
          const modulo = cfg.MODULO.trim();
          if((modulo === "ATENDIMENTO" || modulo === "FATURAMENTO") && cfg.CONTEUDO) { values[cfg.CAMPO] = cfg.CONTEUDO; }
        }
        if(editar && moment().format("YYYY-MM-DD") !== moment(request.row.DATA_INCLUSAO, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD") &&
          values.PEP_ALTERA_EXCLUI_PASSADO != "1" && values.ALT_ATEND_DIF_HOJE != "1") {
          vm.erroFichaHistorico = "Não é possível alterar atendimentos em dias diferentes de hoje.";
          last = null;
          return false;
        }
        const paginas = await vm.consultarCamposDasFichas({ FICHAS: [{ ID_ATENDIMENTO_TIPO: parseInt(request.row.ID_ATENDIMENTO_TIPO), SELECIONADO: "1" }], signal: request.controller.signal });
        if(!valid(request)) { return false; }
        if(!paginas.length) { throw new Error("Configuração da ficha indisponível."); }
        await vm.$nextTick();
        if(!valid(request)) { return false; }
        const editor = vm.$refs.atendimentoFichaDados;
        if(!editor) { throw new Error("Editor indisponível."); }
        const settings = [
          ["TAMANHO_FONTE_ATENDIMENTO", "inserirConfiguracaoTamanhoFonteAtendimento"],
          ["NOME_FONTE_ATENDIMENTO", "inserirConfiguracaoNomeFonteAtendimento"],
          ["ALTURA_TELA_ATENDIMENTO", "inserirConfiguracaoAlturaTelaAtendimento"],
          ["SINAL_RESUL_CAMPO_CALC", "inserirConfiguracaoSinalResulCampoCalc"]
        ];
        for(const [name, method] of settings) { if(values[name]) { editor[method](values[name]); } }
        const result = await editor.inicializa({ paginas, dadosHoje: [request.row], preservar: applied?.rowKey === rowKey && applied?.context === request.context, vigente: () => valid(request) });
        if(result === false || !valid(request)) { return false; }
        vm.atendimentosTipoItens = paginas;
        vm.atendimentosHoje = [request.row];
        vm.fichaHistoricoAtendimento = request.row;
        vm.fichaDadosVisualizacao = !editar;
        vm.fichaHistoricoPronta = true;
        applied = request;
        return true;
      } catch(error) {
        if(valid(request)) { vm.fichaHistoricoPodeRepetir = true; vm.erroFichaHistorico = "Não foi possível carregar a ficha. Os dados em edição foram mantidos. Tente novamente."; }
        return false;
      } finally {
        request.promise = null;
        if(current === request && !disposed) { loading(false); }
      }
    });
    return request.promise;
  }
  return {
    abrir, cancelar,
    tentarNovamente() { return last && last.context === context(vm) ? abrir(last.editar, last.row) : Promise.resolve(false); },
    invalidar() { cancelar(); if(vm.$refs.modalDetalhe?.showModal) { vm.$refs.modalDetalhe.fecharModal(); } },
    encerrar() { disposed = true; cancelar(); }
  };
}
